import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';

export interface LoginPayload {
  username: string;
  password: string;
}

export interface LoginResponse {
  token: string;
}

export interface LoginGovFormData {
  action: string;
  data: {
    SAMLRequest: string;
  };
}

export interface AuthGovRequest {
  samlart?: string;
}

@Injectable({ providedIn: 'root' })
export class AuthService {
  constructor(private httpClient: HttpClient) {
  }

  public getToken(payload: LoginPayload): Observable<LoginResponse> {
    return this.httpClient.post<LoginResponse>(`${environment.apiBasePath}/token/obtain`, payload);
  }

  public authLoginGovPl(payload: AuthGovRequest): Observable<LoginResponse> {
    return this.httpClient.post<LoginResponse>(`${environment.apiBasePath}/logingov-token/obtain`, payload);
  }

  public getLoginFormData(): Observable<LoginGovFormData> {
    return this.httpClient.post<LoginGovFormData>(`${environment.apiBasePath}/login-gov/form-data`, {});
  }
}
